import { Compass } from 'lucide-react'
import { Link } from 'react-router-dom'
import { AuthLayout } from '@/modules/auth/ui/components'
import { EmptyState } from '@/shared/ui/components'
import { Button } from '@/shared/ui/primitives'

export function NotFoundPage() {
  return (
    <AuthLayout
      title="Page not found"
      subtitle="That address doesn't match anything in the Command Center."
    >
      <EmptyState
        icon={Compass}
        heading="Nothing here"
        description="The link may be out of date, or the page may have moved. Head back and try again from the dashboard."
        action={
          <Button asChild className="w-full">
            <Link to="/">Go home</Link>
          </Button>
        }
      />
    </AuthLayout>
  )
}
